import { create } from 'zustand'

interface DevGateState {
  isUnlocked: boolean
  unlock: () => void
  lock: () => void
}

export const useDevGateStore = create<DevGateState>((set) => ({
  // Auto-unlock in development, check sessionStorage in production
  isUnlocked: import.meta.env.DEV || sessionStorage.getItem('devUnlocked') === 'true',

  unlock: () => {
    sessionStorage.setItem('devUnlocked', 'true')
    set({ isUnlocked: true })
    console.log('Dev mode unlocked')
  },

  lock: () => {
    sessionStorage.removeItem('devUnlocked')
    set({ isUnlocked: false })
    console.log('Dev mode locked')
  },
}))
